import { useMutation, useQueryClient } from "@tanstack/react-query";

import { registerRunner } from "./api";
import type { RunnerRegistrationResponse } from "./api";

// Регистрация self-hosted раннера. На успех инвалидируем `runners`
// (новая строка в списке) и `queue` (у организации появилась очередь —
// `GET /queue` перестанет отдавать `queue: null`). Токен из ответа в
// query cache не кладём — он уходит только вызывающему компоненту
// (показывается один раз, см. `features/runners/api.ts`). Он всё же
// живёт в `data` этой мутации (TanStack Query `MutationCache`) до
// `reset()` или размонтирования — вызывающий (`RunnersSection`) зовёт
// `reset()` по закрытию модалки показа токена.
export function useRegisterRunner(): ReturnType<
  typeof useMutation<RunnerRegistrationResponse, Error, string>
> {
  const queryClient = useQueryClient();
  return useMutation<RunnerRegistrationResponse, Error, string>({
    mutationFn: (name) => registerRunner(name),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["runners"] });
      void queryClient.invalidateQueries({ queryKey: ["queue"] });
    },
  });
}
